module.exports = __webpack_public_path__ + "static/img/6.73945a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/6.png
// module id = FGgF
// module chunks = 0